import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-10 mx-auto" }

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import AdvisersList from "@/guiide/components/common/AdvisorsList.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Advisers',
  setup(__props) {

const store = useStore();
const displayAdviceReasons = ref(false);

onMounted(() => {
  displayAdviceReasons.value = store.state.configuration.guiidePlusAdvisersShowsAdviceReasons;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[11] || (_cache[11] = _createElementVNode("header", { class: "text-center mb-4" }, [
      _createElementVNode("h2", { class: "skin-page-heading" }, "Advisers")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("p", null, [
          _createElementVNode("strong", null, "Do you need some financial advice?")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, " Guiide can build you a plan of how to build up and take your money in retirement, but we can't give you financial advice. Examples of this advice is where to invest your pension pots, what products are best for you or how to deal with more complicated tax issues. ", -1)),
        (displayAdviceReasons.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[0] || (_cache[0] = _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Sometimes you must take advice!")
              ], -1)),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, " If you want to consider transferring a final salary pension scheme, you must take advice from a specialist transfer adviser if your transfer value is over £30,000. The cost of this advice will range between £3,000 and £10,000, regardless of whether the advice is to stay in the scheme or transfer. There are now far fewer specialist advisers who provide this advice. ", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                _createTextVNode(" Our separate "),
                _createElementVNode("a", {
                  href: "https://www.db.guiide.co.uk/index",
                  target: "_blank"
                }, "Guiide DB journey"),
                _createTextVNode(" helps people understand the FCA's view on the type of people where a transfer is clearly not in their best interests and signposts specialist advisers if appropriate. You will need a code to start this journey via this link. Please email "),
                _createElementVNode("a", { href: "mailto:contact@guiide.co.uk" }, "contact@guiide.co.uk"),
                _createTextVNode(" to get one. ")
              ], -1))
            ], 64))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, [
          _createElementVNode("strong", null, "How much does retirement advice cost?")
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, " In short, it depends on the advice needed. As an example, retirement advice on selecting a mix of products, providers and suitable investments may be around 1-2% of the value of your pots, with a minimum fixed cost at lower pot levels. If cost is a major factor please obtain quotes from each adviser. ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, " To help, most advisers offer a free or low cost meeting to start with. The Government also allows people in defined contribution pension schemes to withdraw up to £500 tax free from their pension pot to pay towards retirement advice, if your pension provider allows this. ", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Our adviser panel", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, " Before adding any adviser to our panel, our independent compliance consultants check the experience, track record and capability of each adviser we select. ", -1)),
        _createVNode(AdvisersList, { "always-display": true }),
        _cache[10] || (_cache[10] = _createElementVNode("p", null, [
          _createElementVNode("small", null, "Disclaimer - We do not take any referral fees from any advisers above. Some advisers may license our tools for their own use, so we do have commercial relationships. ")
        ], -1))
      ])
    ])
  ], 64))
}
}

})